import React from "react";
import {
  Button,
  Form,
  TextInput,
  PasswordInput,
} from "carbon-components-react";
import { ArrowRight24, CheckboxChecked32 } from "@carbon/icons-react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import http from "../../http-common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import UserForm from "./UserForm";

const requiredMessage = "Campo obrigatório";
const invalidNuit = "NUIT inválido";

const userSchema = yup.object({
  firstName: yup.string().required(requiredMessage),
  lastName: yup.string().required(requiredMessage),
  username: yup
    .string()
    .required(requiredMessage)
    .length(9, invalidNuit)
    .matches(/^[0-9]*$/, invalidNuit),
  email: yup.string().required(requiredMessage).email("Email inválido"),
  password: yup.string().required(requiredMessage),
});

const SignupPage = () => {
  return (
    <div className="bx--row">
      <div className="bx--col-lg-6 content">
        <h1 className="title">Critérios de Elegibilidade</h1>
        <p>
          A competição de desenvolvimento de Plataformas Digitais é reservada a
          empresas de direito Moçambicano especializadas em tecnologias de
          informação e comunicação, tecnologia financeira ("fintech"), ou
          soluções digitais.
        </p>
        <p>
          <strong>Tipo de Entidade:</strong> Empresas registadas, "startups",
          organizações sem fins lucrativos, ou indivíduos empreendedores.
        </p>

        <p>
          <strong>Relevância:</strong> A plataforma deve estar directamente
          relacionada com serviços de ligação a mercados ou ligação a serviços
          financeiros.
        </p>

        <p>
          <strong>Possuir Registo Formal:</strong> Registo legal para o
          exercício da actividade em Moçambique (alvará, licenças para o
          exercício da actividade, certidão comercial).
        </p>

        <p>
          <strong>Tempo de Operação:</strong> Pelo menos seis meses de operação
          no mercado.
        </p>

        <p>
          <strong>Estágio de Desenvolvimento:</strong> Protótipo funcional,
          mínimo produto viável (MVP), ou soluções já no mercado.
        </p>

        <p>
          <strong>Origem do Capital:</strong> Pelo menos 10% do capital social
          detido por Moçambicanos (documento de constituição da empresa).
        </p>
      </div>
      <div className="bx--col-sm-12 bx--col-lg-6">
        <Card title="Regista-te">
          {/* <UserForm
            mode={"SIGNUP"}
            url={"/auth/signup"}
            successMessage="Conta Criada com sucesso"
            onSuccessNavigateTo={"/"}
          /> */}
          <p>O período de candidaturas terminou no dia 2 de Junho.</p>
        </Card>
      </div>
    </div>
  );
};

export default SignupPage;
